import axios from "axios";
import React, { useRef, useState } from "react";
import emailjs from '@emailjs/browser';

const RecuContrase = () => {

    const form = useRef()

    const [recuperar, setRecupera] = useState({
        user_email: '',
        telefono: ''
    })

    const inputChange = ({target}) => {
        const {name, value} = target
        setRecupera({
            ...recuperar,
            [name]: value
        })
    }

    const enviarEmail = () => {
        emailjs.sendForm('service_cse3y8o', 'template_qtlqn5o', form.current, 'yfNAvbGT75WmmKIYJ')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        })
    }

    const cambiar = async (e) => {
        e.preventDefault()
        await axios.post('http://localhost:9000/recuperarcontra', recuperar)
        .then(({data}) => {
            if(data.message === 'Cambio realizado'){
                enviarEmail();
                alert('Se envio el correo')
            }
        })
    }

    return(
        <div className="text-center">
            <form onSubmit={cambiar} ref={form}>
                <div>
                    <label htmlFor="">Correo Electronico</label>
                    <input 
                        type="email" 
                        name="user_email" 
                        id="" 
                        value={recuperar.user_email}
                        onChange={inputChange}
                    />
                </div>
                <div>
                    <label htmlFor="">Telefono</label>
                    <input 
                        type="text"    
                        name="telefono"
                        value={recuperar.telefono}
                        onChange={inputChange}
                    />
                </div>
                <div>
                    <button className="btn btn-success" type="submit">Enviar</button>
                </div>
            </form>
        </div>
    )

}

export default RecuContrase